import { providerService } from '@/api'

const initialState = () => ({
  all: [],
  cache: false
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    asOptions: state =>
      state.all.map(i => ({
        id: i.provider_user_id,
        name: i.provided_name || i.email,
        avatar: i.avatar
      }))
  },
  actions: {
    async find({ state, commit }, bustCache = false) {
      if (state.all.length && state.cache) return state.all
      try {
        const result = await providerService.find({
          service: 'users'
        })
        commit('set', result)
        commit('cache', true)
        return result
      } catch (err) {
        console.error(err)
      }
    }
  },
  mutations: {
    set(state, data) {
      state.all = data
    },
    cache(state, newVal) {
      state.cache = newVal
    }
  }
}
